import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import './MyGroup.css';

const MyGroup = () => {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      loadGroups();
    }
  }, [isLoggedIn]);

  const checkLoginStatus = () => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
    if (!token) {
      setLoading(false);
    }
  };

  const loadGroups = async () => {
    try {
      const result = await homeApi.getFlowGroups({ page: 1 });
      
      if (result.code === 200) {
        setGroups(result.data.data || []);
      } else {
        alert(result.msg || '获取数据失败');
      }
    } catch (error) {
      console.error('获取圈子列表失败:', error);
      alert('获取数据失败');
    } finally {
      setLoading(false);
    }
  };

  const handleGroupClick = (groupId) => {
    navigate(`/circle/details/${groupId}`);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goHome = () => {
    navigate('/home');
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="my-group-page">
      <Navbar title="我的圈子" />

      <div className="content-container">
        <div className="header">
          <div className="header-title">
            <span className="title-text">我关注的圈子</span>
          </div>
          <div className="header-icon">
            <span>📰</span>
          </div>
        </div>

        <div className="header-desc">
          <span>你喜欢的圈子全在这里</span>
        </div>

        {groups.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">📭</span>
            <span className="empty-text">暂无关注的圈子</span>
          </div>
        ) : (
          <div className="group-list">
            {groups.map((item) => (
              <div key={item.id} className="group-card" onClick={() => handleGroupClick(item.id)}>
                <div className="group-image" style={{ backgroundImage: `url(${item.image})` }}>
                  <div className="image-mask"></div>
                </div>
                <div className="group-info">
                  <div className="group-title">{item.title}</div>
                  <div className="group-desc">{item.title_sub}</div>
                  <div className="group-stats">
                    <span className="stat-item">
                      <span className="stat-icon">👥</span>
                      <span className="stat-text">关注{item.follow_num}</span>
                    </span>
                    <span className="stat-item">
                      <span className="stat-icon">📝</span>
                      <span className="stat-text">帖子{item.goods_num}</span>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav activeTab="home" />
    </div>
  );
};

export default MyGroup;
